import { configureStore, createSlice } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";

/* ยังไม่มี state กลาง — เตรียมไว้ให้โมดูลถัดไปเพิ่ม slice ของตัวเอง */
const appSlice = createSlice({ name: "app", initialState: {}, reducers: {} });

export const store = configureStore({
  reducer: { app: appSlice.reducer },
  devTools: process.env.NODE_ENV === "development",
});

export const useAppDispatch = () => useDispatch();
